import { Component } from '@angular/core';

@Component({
    selector: 'app-relatorio-interplantas-automatico',
    templateUrl: './relatorio-interplantas-automatico.component.html',
    styleUrls: ['./relatorio-interplantas-automatico.component.css'],
    standalone: false
})
export class RelatorioInterplantasAutomaticoComponent {

}
